import { OtAttempt2 } from "./PositionStats";

export const getAverageEval = (attempts: OtAttempt2[]): string => {
    const averageEval =
        attempts.reduce((acc, attempt) => {
            const ev = parseFloat(attempt.evaluation);
            // cap ev to max 10 and min -9.75
            const cappedEv = Math.min(10, Math.max(-9.75, ev));
            return cappedEv + acc;
        }, 0) / attempts.length;

    if (isNaN(averageEval)) {
        return "";
    }
    return averageEval.toFixed(1);
};

export const getRatingChangeLastXAttempts = (attempts: OtAttempt2[], x: number): number => {
    return attempts.slice(-x).reduce((acc, attempt) => acc + parseFloat(attempt.ratingGain), 0);
};
